<template>
  <div class="examPage container-fluid">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="bg-white shadow-sm">
      <div class="row">
        <div class="col-12 bg-light pb-5 pb-lg-0">
          <div class="row no-gutter">
            <div class="col-12 py-2 px-0 d-flex just`ify-content-between justify-content-md-end align-items-center">
              <a href="https://www.magee.tw/">馬跡官網</a>
              <span class="text-secondary">｜</span>
              <router-link to="/">返回試題選單</router-link>
              <span class="text-secondary">｜</span>
              <span  class="ml-1 small" v-if="$route.params.method === 'VIP'">
                <!-- 會員專區 -->
                HI,
                {{userInfo.member_id}}</span>
              <button v-else class="ml-1 btn btn-link p-0" @click="login()">登入</button>
            </div>
          </div>
        </div>
      </div>
      <div class="row d-none d-lg-block no-gutters">
        <div class="col-12">
          <b-card img-src="/img/topBanner_all3.png" img-alt="Image" img-top tag="article" no-body>
            <!-- <b-button variant="primary" @click="noSingle()">整頁模式</b-button>
            <b-button variant="primary" @click="isSingle()">單題模式</b-button>-->
          </b-card>
        </div>
      </div>
      <div class="row sticky-top no-gutters"
            style="margin-top:-42px">
        <div class="col-12 position-relative">
          <div class="d-block d-lg-flex flex-md-row align-items-stretch">
            <b-nav tabs align="left" class="myNav bg-transparent letter-s-2 w-100">
              <b-nav-item class="ml-lg-5"
                :link-classes="{'active text-deepgold disabled':!allwaysAns,'rounded-0':true}"
                @click="ChangeAllwaysAns('hideAns')">計時交卷</b-nav-item>
              <b-nav-item :link-classes="{'active text-deepgold disabled':!finish && allwaysAns,'rounded-0':true}"
                @click="ChangeAllwaysAns('showAns')">隨答隨改</b-nav-item>
            </b-nav>
          </div>
          <div class="position-absolute w-100 h-100"
            style="margin-top:-42px;z-index:-1;background:rgba(255,255,255,0.8)">
          </div>
        </div>
        <div class="col-12">
          <b-nav tabs align="left" class="myNav d-flex justify-content-between align-items-center">
            <div
              class="pl-lg-5 d-flex justify-content-start align-items-center flex-fill flex-wrap">
              <div class="text-sevenblack" style="min-width:7.5em">
                <span v-if="!allwaysAns"
                  class="px-3 order-xl-0 order-lg-0 order-md-0 order-sm-1 order-1 d-inline-flex">
                  <font-awesome-icon :icon="['far', 'clock']" class="mr-2"
                    style="font-size:1.5rem" />
                  {{ later | moment("HH:mm:ss") }}
                </span>
              </div>
              <b-button-group size="sm" class="py-3">
                <button @click="noSingle()" class="btn"
                  :class="{'btn-light text-sevenblack active':single,'btn-gold':!single}">整頁顯示</button>
                <button @click="isSingle()" class="btn"
                  :class="{'btn-light text-sevenblack active':!single,'btn-gold':single}">逐題顯示</button>
              </b-button-group>
              <div class="order-2 ml-auto mr-2 my-2" v-if="!allwaysAns">
                <b-button v-if="finish" variant="primary" class="d-none d-md-block" size="lg"
                  @click="reloadPage()">
                  <font-awesome-icon :icon="['fas', 'pen']" class="mr-2" />重新作答
                </b-button>
                <!-- phone show -->
                <div class="d-md-none d-block phoneshow position-absolute"
                  style="right:0;top:-35px">
                  <b-button v-if="!finish" variant="danger" size="md" @click="showMsgBoxOne">
                    <font-awesome-icon :icon="['fas', 'scroll']" class="mr-1" />
                    我要交卷
                  </b-button>
                  <b-button v-if="finish" variant="primary" size="md"
                    class="text-nowrap phoneshow position-absolute" style="right:0;top:0px"
                    @click="reloadPage()">
                    <font-awesome-icon :icon="['fas', 'pen']" class="mr-1" />
                    重新作答
                  </b-button>
                </div>
              </div>
            </div>
            <!-- <b-form-checkbox v-model="showDetial" :value="true" :unchecked-value="false">顯示全部解析</b-form-checkbox> -->
          </b-nav>
        </div>
        <div class="col-12">
          <div
            class="exam_name_bar justify-content-start align-items-center py-2 py-md-3 text-center myNav shadow-sm">

            <h4 class="px-2 mb-0 d-none d-lg-block text-gold letter-s-1 font-weight-bold">
              {{ examTitle.name }}
            </h4>
            <h4 class="px-2 mb-0 d-block d-lg-none text-gold letter-s-1 font-weight-bold">
              {{ examTitle.phoneName }}
            </h4>
          </div>
        </div>
      </div>
      <div class="row" v-if="finish === true || openAna === true">
        <div class="col-12 px-md-0">
          <div v-if="!allwaysAns" class="d-flex flex-column align-items-center my-lg-4 py-3">
            <div class="d-inline-block text-left">
              <span class="text-secondary">您的分數為</span>
              <div class="d-flex justify-content-md-center w-100 py-3">
                <!-- <h1 id="myScore">{{score.showall}}</h1> -->
                <div class="d-inline-block mr-1" v-for="(i,key) in score.split" :key="key">
                  <img :src="'/img/num'+i+'.png'" alt="" width="115" />
                </div>
                <div class="d-inline-block align-self-end">
                  <img src="/img/numUnit.png" alt="" width="75">
                </div>
              </div>
            </div>
            <div class="pb-4 text-secondary" v-if="false">
              <span v-if="(parseInt(score.showall) >= 80)" class="">您考的非常好！</span>
              <span v-else-if="(parseInt(score.showall) >= 60) && (parseInt(score.showall) <= 79)"
                class="">考得很好，繼續保持！</span>
              <span v-else-if="(parseInt(score.showall) >= 40) && (parseInt(score.showall) <= 59)"
                class="">再接再厲！加油！</span>
              <span v-else-if="(parseInt(score.showall) >= 20) && (parseInt(score.showall) <= 39)"
                class="">繼續努力！</span>
              <span v-else-if="(parseInt(score.showall) <= 19 && parseInt(score.showall) != 0)"
                class="">別放棄，還有機會！</span>
            </div>
          </div>
          <div class="row" v-if="$route.params.examId.substr(2, 1) === '2'">
            <div class="col-12 col-md-6 d-flex flex-fill justify-content-center overflow-auto">
              <lineChart class="col-12 px-0 px-md-3" style="height: 420px" :pro_unit_code="unit_code"
                :pro_unit_code_ob="unit_code_ob"></lineChart>
            </div>
            <div class="col-12 col-md-6 d-flex flex-column justify-content-center" style="user-select: none">
              <h5 class="mt-5 mt-md-0 mb-3 text-center font-weight-bold">落點分析</h5>
              <div class="d-flex flex-column border font-up-1">
                <div class="row bg-light border-bottom text-center font-weight-bold">
                  <div class="col-4 text-left text-nowrap px-1 py-2 border-right">單元佔比</div>
                  <div class="col-2 text-nowrap px-1 py-2 border-right" v-if="!allwaysAns">答題數</div>
                  <div class="col-2 text-nowrap px-1 py-2 border-right">出題數</div>
                  <div class="col-2 text-nowrap px-1 py-2 border-right" v-if="!allwaysAns">得分</div>
                </div>
                <analyzeItem v-for="(item, index) in unit_code" :key="index" :item="item" :index="index" :unit_code_ob="unit_code_ob" :allwaysAns="allwaysAns" :totalQuestion="totalQuestion"/>
                <div class="row">
                  <div class="col-4 pl-1 bg-light px-1 py-2 border-right">總計</div>
                  <div class="col-2 text-right px-1 py-2 border-right" v-if="!allwaysAns">{{score.showall/(100/totalQuestion)}}
                  </div>
                  <div class="col-2 text-right px-1 py-2 border-right">{{totalQuestion}}</div>
                  <div class="col-2 text-right px-1 py-2 border-right" v-if="!allwaysAns">{{score.showall}}</div>
                  <div class="col-2 d-flex text-nowrap p-0">
                    <a href="javascript:;" class="m-auto" @click.prevent="showMoreInfo = !showMoreInfo">及格標準</a>
                  </div>
                </div>
                <b-collapse class="border-top bg-light" v-model="showMoreInfo" accordion="moreInfo">
                  <div :colspan="(!allwaysAns)? '5':'3'" class="text-center">
                    <div class="d-inline-flex flex-column text-left py-1">
                      <small>※應考科目：執業實務(*實務一)、執業法規(*實務二)、觀光資源、外國語</small>
                      <small>※門檻計算：應考科目分數、全部加總、及格分數如下</small>
                      <small>
                        <ul class="mb-0">
                          <li>華語考生－總分需達到180分以上(外國語科目免試)</li>
                          <li>外語考生－總分需達到240分以上(應試－科外語不試用)</li>
                        </ul>
                      </small>
                      <small>*考選部體制下為實務一、實務二，自113年起改為觀光署舉辦後，考科名稱改為執業實務、執業法規</small>
                    </div>
                  </div>
                </b-collapse>
              </div>
              <!-- <table class="table table-bordered table-sm mt-4 font-up-1 mr-lg-5">
                <colgroup>
                  <col class="bg-light">
                  <col>
                  <col>
                  <col>
                  <col>
                </colgroup>
                <thead>
                  <tr class="bg-light">
                    <th class="text-nowrap">單元佔比</th>
                    <th class="text-nowrap" v-if="!allwaysAns">答題數</th>
                    <th class="text-nowrap">出題數</th>
                    <th class="text-nowrap" v-if="!allwaysAns">得分</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in unit_code" :key="index">
                    <td>
                      <span class="d-inline-block text-truncate" style="max-width: 8em;">
                        {{item}}
                      </span>
                    </td>
                    <td class="text-right" v-if="!allwaysAns">{{unit_code_ob[item].correct}}</td>
                    <td class="text-right">{{unit_code_ob[item].count}}</td>
                    <td class="text-right" v-if="!allwaysAns">
                      {{(100/totalQuestion)*unit_code_ob[item].correct}}</td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td>總計</td>
                    <td class="text-right" v-if="!allwaysAns">{{score.showall/(100/totalQuestion)}}
                    </td>
                    <td class="text-right">{{totalQuestion}}</td>
                    <td class="text-right" v-if="!allwaysAns">{{score.showall}}</td>
                    <td class="text-nowrap">
                      <a href="" @click.prevent="showMoreInfo = !showMoreInfo">及格標準</a>
                    </td>
                  </tr>
                  <tr v-if="showMoreInfo">
                    <td :colspan="(!allwaysAns)? '5':'3'" class="text-center">
                      <div class="d-inline-flex flex-column text-left py-1">
                        <small>※應考科目：實務一、實務二、觀光資源、外國語</small>
                        <small>※門檻計算：應考科目分數、全部加總、及格分數如下</small>
                        <small>
                          <ul class="mb-0">
                            <li>華語考生－總分需達到180分以上(外國語科目免試)</li>
                            <li>外語考生－總分需達到240分以上(應試－科外語不試用)</li>
                          </ul>
                        </small>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table> -->
            </div>
          </div>
        </div>
      </div>
      <div class="row" v-if="finish === true || openAna === true">
        <div class="col-12 text-center py-4 my-lg-4">
          <b-button variant="deepgold" class="mr-3" v-if="!allwaysAns" v-b-toggle.finish-close>回顧考題
          </b-button>
          <router-link to="/" class="btn btn-outline-deepgold">返回試題選單</router-link>
        </div>
      </div>
      <div class="mycard position-relative">
        <b-collapse :visible="finish === false || allwaysAns" id="finish-close">
          <div class="col-10 mx-auto" v-if="finish === true && !allwaysAns">
            <hr class="border-secondary mb-0 w-100" />
          </div>
          <questions @qkey2="getqkey" @proqkey2="getqkey2" :qkeyf2="qkeyf2" @emitTag="emitTag"
            :proqkey="qkeyf" :proTip="tip" :proRe="reload" :proStatus="ansStatus"
            :proOpenAns="openAns">
          </questions>
          <div class="right_position position-fixed">
            <div class="d-flex flex-md-column justify-content-center align-items-center">
              <button type="button" class="btn btn-gold flex-fill" v-b-toggle.AnserCard
                @click="openAnsCard()">我的答案卡</button>
              <button type="button" class="btn btn-lightgold text-gold mx-0 mx-md-0 my-md-3 flex-fill" style="border-color:#ebdeca"
                @click="toWithout()">到未作答題目</button>
              <button type="button" class="btn btn-lightgold text-gold flex-fill" @click="totop()" style="border-color:#ebdeca">返回第一題</button>
            </div>
          </div>
        </b-collapse>
      </div>
      <!-- ========================== -->
      <b-sidebar id="AnserCard" title="我的答案卡" shadow>
        <template #default="{ hide }">
          <div id="toq_2" class="position-fixed text-center border m-0 w-100">
            <div class="qbtn p-3 border-bottom">
              <div class="toq_width d-flex flex-wrap justify-content-start w-100">
                <div v-for="(item, index) in AllAns" :key="index"
                  v-scroll-to="{ element: `#__q${index + 1}`, offset: -130 }"
                  @click="quick_setQ(item.group, index);hide()" style="width:50px"
                  class="d-flex mr-1 mb-1">
                  <div class="w-100"
                    :class="{active:(!allwaysAns&&selectedAns[index])|| (allwaysAns &&selectedStatus[index])}">
                    {{index + 1}}
                  </div>
                  <div class="num w-100" v-if="!openAns" style="letter-spacing: -1px;">
                    {{selectedAns[index]}} <span class="text-deepgold"
                      v-if="tempTag[index]===true">?</span></div>
                  <div v-else class="w-100" style="letter-spacing: -1px;"
                    v-for="(j, index2) in item.ans" :key="index2"
                    :class="{'text-success':selectedAns[index]==j,'text-danger':selectedAns[index]!=j}">
                    {{j}} <span v-if="tempTag[index]===true" class="text-secondary">?</span>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-start mt-3">
                <div class="d-flex flex-column">
                  <div class="d-flex">
                    <div class="border mx-1" style="width:20px;background: rgb(255, 221, 170);">
                    </div>
                    <span class="mr-1">已答題</span>
                    <span
                      v-if="!allwaysAns">{{`${Object.keys(selectedAns).length} / ${totalQuestion}`}}
                      題</span>
                    <span v-else>{{`${Object.keys(selectedStatus).length} / ${totalQuestion}`}}
                      題</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="py-3 px-4 border-bottom text-left" v-if="allwaysAns">
              <!-- <span class="p-3 bg-primary rounded text-white">隨答隨改</span> -->
              <b-form-checkbox v-if="$route.params.examId.substr(2, 1) === '2'" v-model="openAna"
                :value="true" :unchecked-value="false">顯示題型分析
              </b-form-checkbox>

              <b-form-checkbox v-model="openAns" :value="true" :unchecked-value="false">顯示全部答案
              </b-form-checkbox>
            </div>
            <div class="close_bottom_toq d-flex justify-content-between p-3">
              <div>
                <button class="btn btn-sm btn-outline-primary mr-1">
                  <router-link to="/">返回試題選單</router-link>
                </button>
              </div>
              <div style="padding-right: 20px">
                <b-button variant="danger" size='sm' class='mr-1' @click="showMsgBoxOne"
                  v-if="!allwaysAns&&!finish">
                  我要交卷
                </b-button>
                <b-button variant="light" size="sm" class="border" @click="hide">關閉</b-button>
              </div>
            </div>
          </div>
        </template>
      </b-sidebar>
      <!-- ========================== -->
      <publicfooter class="pl-3 pr-3 pt-2 pb-2">
      </publicfooter>
    </div>
    <!--  -->
    <div class="reprot-btn text-center font-weight-bold" :style="scrollshow">
      <b-button variant="danger" class="d-none d-md-block small" @click="showMsgBoxOne"
        v-if="!allwaysAns&&!finish">
        <!-- <font-awesome-icon :icon="['fas', 'scroll']" class="mr-1" /> -->
        我要<br>交卷
      </b-button>
      <b-button variant="white" class="d-none d-md-block small" @click="openAns=!openAns"
        v-else-if="allwaysAns">
        <!-- <font-awesome-icon :icon="['fas', 'scroll']" class="mr-1" /> -->
        {{(openAns==false)? '顯示':'隱藏'}}<br>答案
      </b-button>
    </div>
    <b-modal hide-footer size="sm" id="modal-login" body-class="px-0 pt-0" header-class="p-0 m-0"
      centered>
      <template #modal-header="{ close }">
        <div class="position-relative w-100">
          <div class="w-100 d-flex pt-2 letter-s-2 align-items-stretch">
            <div href="#"
              class="px-1 pb-2 pt-3 w-50 m-0 border-bottom border-deepgold border-b-3 text-center">
              <b class="text-deepgold h5 mb-0">會員登入</b>
            </div>
            <div class="border-bottom border-light w-50">
            </div>
          </div>
          <button type="button" aria-label="關" class="position-absolute close py-2 px-3"
            style="right:1rem;top: 1rem;line-height:17px;" @click="close()">
            <font style="vertical-align: inherit;">×</font>
          </button>
        </div>
      </template>
      <div class="bg-light pt-4 pb-2 mb-2">
        <comlogin></comlogin>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import ctrl from './js/exam';

  export default ctrl;

</script>
